import { ComponentType, ReactNode } from 'react';
import styled from 'styled-components';
import { EmptyState } from 'ui/emptyState';
import { spacing } from 'ui/theme';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: ${spacing.x32};
  justify-content: center;
  max-width: ${spacing.x48};
  padding-right: ${spacing.double};
  padding-left: ${spacing.double};
  margin-right: auto;
  margin-left: auto;
`;

type CustomEventsEmptySpaceStateProps = {
  Icon: ComponentType<React.PropsWithChildren<unknown>>;
  title: string;
  subtitle: ReactNode;
};
export const CustomEventsEmptyState = ({
  Icon,
  title,
  subtitle,
}: CustomEventsEmptySpaceStateProps) => (
  <Container>
    <EmptyState Illustration={Icon} title={title} subtitle={subtitle} />
  </Container>
);
